import { Control, Controller } from 'react-hook-form'

import { TextField } from '@mui/material'
import { PublicVisibilitySelector } from 'common/components/PublicVisibilitySelector'
import { PublicVisibility, Video } from 'features/videos/service'

type Props = {
  control: Control<Video>
}

export const PublicVisibilityController = ({ control }: Props) => {
  return (
    <Controller
      control={control}
      name={'publicVisibility'}
      rules={{ required: 'Выберите публичность видео' }}
      render={({ field, fieldState }) => (
        <PublicVisibilitySelector
          value={field.value as PublicVisibility}
          onChange={field.onChange}
          errorMessage={fieldState.error?.message}
        />
      )}
    />
  )
}
